import { IDynamicUrlResponseV2, ISearchContext } from "api/interfaces/search.type";
import axios from "../../fetch-api/fetch-api";

export function getDynamicUrlPrefixApi(context: ISearchContext, skuQueryParams: string) {
  const baseUrl = "/get-dynamic-url-by-autocomplete-result";
  const getDynamicUrlApi = skuQueryParams ? `${baseUrl}?${skuQueryParams}` : baseUrl;

  return axios.get<IDynamicUrlResponseV2>(getDynamicUrlApi, {
    params: {
      ...context,
    },
  });
}
